import React from "react";

import ReactDOM from "react-dom/client";
import { Provider } from "react-redux";
import { BrowserRouter } from "react-router-dom";
import { Toaster } from "sonner";

import { store } from "@/store/store";
import AuthProvider from "@/core/providers/AuthProvider";
import { SessionProvider } from "@/lib/session";
import { ErrorBoundary } from "@/shared/ui/error-boundary/ErrorBoundary";
import { TooltipProvider } from "@/shared/ui/tooltip/Tooltip";

import { App } from "./App";

// Design tokens (Tailwind v4 @theme + brand token ramps). Import once.
import "@/core/theme/tokens.css";

// SPA provider tree — the react-router equivalent of the former Next
// root `layout.tsx`. Store + client session (replaces next-auth) + app
// auth bootstrap wrap the router. API integration (store/apis) is kept
// as per dev; the session mechanism is the new client-side one.
const rootEl = document.getElementById("root");
if (!rootEl) throw new Error("#root element not found");

ReactDOM.createRoot(rootEl).render(
  <React.StrictMode>
    <Provider store={store}>
      <SessionProvider>
        <AuthProvider>
          <ErrorBoundary>
            <TooltipProvider>
              <BrowserRouter>
                <App />
                <Toaster position="top-right" richColors closeButton duration={4000} />
              </BrowserRouter>
            </TooltipProvider>
          </ErrorBoundary>
        </AuthProvider>
      </SessionProvider>
    </Provider>
  </React.StrictMode>
);
